if (!customElements.get('judgme-wrapper')) {
    customElements.define(
      'judgme-wrapper',
      class JudgemeWrapper extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.target.classList.contains('jdgm-carousel--done')) {
                this.observer.disconnect();
                this.onWidgetDone();
              }
            });
          });
          this.observer.observe(this.querySelector('.jdgm-widget'), { attributes: true, filter: 'class' });
        }

        onWidgetDone() {
          this.querySelectorAll('.jdgm-carousel-item__inner-wrapper').forEach((card) => {
            const nameWrapper = card.querySelector('.jdgm-carousel-item__reviewer-name-wrapper');
            const starsElement = card.querySelector('.jdgm-carousel-item__review-rating');
            if (nameWrapper && starsElement) {
              nameWrapper.appendChild(starsElement);
            }
          });
        }

        disconnectedCallback() {
         if (this.observer) {
          this.observer.disconnect();
         }
        }
      }
    );
  }
